import React, { useState } from 'react';
import s from './s.module.less';
import OnboardingStepContainer from '../OnboardingStepContainer';
import RadioOption from '../RadioOption';
import ActionButtons from '../ActionButtons';
import { Alert } from 'antd';

interface BillingMethodStepProps {
    onBillingMethodChange?: (billingMethod: string) => void;
    onBack?: () => void;
    onNext?: () => void;
    onExit?: () => void;
    currentStep?: number;
    totalSteps?: number;
    initialBillingMethod?: string;
}

const billingMethodOptions = [
    { id: 'self-or-in-house', label: 'I bill insurance myself or in-house' },
    { id: 'third-party-biller', label: 'I use a third-party biller' },
    { id: 'headway-grow-or-similar', label: 'I bill through Headway, Grow Therapy, or similar' },
    { id: 'no-insurance-yet', label: "I don't bill insurance yet" },
];

export default function BillingMethodStep({
    onBillingMethodChange,
    onBack,
    onNext,
    onExit,
    currentStep = 7,
    totalSteps = 9,
    initialBillingMethod = '',
}: BillingMethodStepProps) {
    const [selectedMethod, setSelectedMethod] = useState<string>(initialBillingMethod);

    const handleMethodChange = (methodId: string) => {
        setSelectedMethod(methodId);

        if (onBillingMethodChange) {
            onBillingMethodChange(methodId);
        }
    };

    return (
        <>
            <OnboardingStepContainer
                currentStep={currentStep}
                totalSteps={totalSteps}
                title="How do you handle insurance billing?"
                subtitle="This helps us understand your current billing setup."
                showBackButton
                onBack={onBack}
            >
                <Alert
                    icon={
                        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                            <path fillRule="evenodd" clipRule="evenodd" d="M18 10C18 14.4183 14.4183 18 10 18C5.58172 18 2 14.4183 2 10C2 5.58172 5.58172 2 10 2C14.4183 2 18 5.58172 18 10ZM11 6C11 6.55228 10.5523 7 10 7C9.44772 7 9 6.55228 9 6C9 5.44772 9.44772 5 10 5C10.5523 5 11 5.44772 11 6ZM9 9C8.44772 9 8 9.44772 8 10C8 10.5523 8.44772 11 9 11V14C9 14.5523 9.44772 15 10 15H11C11.5523 15 12 14.5523 12 14C12 13.4477 11.5523 13 11 13V10C11 9.44772 10.5523 9 10 9H9Z" fill="#60A5FA" />
                        </svg>
                    }
                    description={<span>Klarity offers managed insurance billing for <strong>3.9% of reimbursement</strong>. Half of the industry average take.</span>}
                    type="info"
                    showIcon
                    className={s.infoAlert}
                    style={{ marginBottom: 16 }}
                />
                
                <div className={s.optionsContainer}>
                    {billingMethodOptions.map((option) => (
                        <RadioOption
                            key={option.id}
                            id={option.id}
                            label={option.label}
                            checked={selectedMethod === option.id}
                            onChange={handleMethodChange}
                        />
                    ))}
                </div>
            </OnboardingStepContainer>

            <ActionButtons
                showBack
                showNext={false}
                currentStep={currentStep}
                onBack={onBack}
            />
        </>
    );
}